// Canonical buyer-stage tone map. Imported by the Journey stage flow and by
// every other page that wants to speak the same visual language.

export type Stage = "discovery" | "evaluation" | "decision" | "retention";

export const STAGE_TONES: Record<Stage, string> = {
  discovery: "var(--brand-accent)",
  evaluation: "var(--signal-violet)",
  decision: "var(--signal-teal)",
  // Coral: retention is the churn-risk lane, visually distinct from the funnel.
  retention: "var(--signal-coral)",
};

/** Tone for an arbitrary stage-ish string; falls back to the brand accent. */
export function stageTone(stage: string | null | undefined): string {
  if (!stage) return "var(--brand-accent)";
  const k = stage.toLowerCase() as Stage;
  return STAGE_TONES[k] ?? "var(--brand-accent)";
}
